import { Component, Input, OnInit } from '@angular/core';
import { BaseModalComponent } from "common-shared";
import { Subject } from 'rxjs';
import {MasterInputInstructionModel, MasterOperationModel, ProcessSelectorModel, SpecLineModel} from "web-shared";
import {IntegratedMasterService} from "../services/integrated-master.service";

@Component({
  selector: 'app-integrated-master-editor-modal',
  templateUrl: './integrated-master-editor-modal.component.html',
  styles: []
})
export class IntegratedMasterEditorModalComponent extends BaseModalComponent implements OnInit {
  @Input() masterOperations: MasterOperationModel[];
  @Input() processSelectors: ProcessSelectorModel[];
  @Input() code: string;
  @Input() specs: SpecLineModel[];
  @Input() readonly: boolean = false;
  @Input() hasCostButton: boolean = false;
  allowItemGroupsAsInputs: boolean = false;
  arePropertiesShown: boolean = false;
  areInValidLinesShown: boolean = false;
  onShowIme = new Subject<MasterInputInstructionModel>();
  onShowCost = new Subject<string>();
  showPhantoms: boolean;

  constructor(private integratedMasterService: IntegratedMasterService) {
    super();
  }

  ngOnInit() {
    this.integratedMasterService.ensureRowGroupKeys({MasterOperations: this.masterOperations, ProcessSelectors: this.processSelectors});
    this.masterOperations = [...this.masterOperations];
  }

  showIme(masterInputInstruction: MasterInputInstructionModel) {
    this.onShowIme.next(masterInputInstruction);
  }

  showCost() {
    this.onShowCost.next(this.code);
  }
}
